import React, { useEffect, useState } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ColumnChart = ({ modelData }: any) => {
  const [data, setData] = useState([[""]]);

  useEffect(() => {
    if (modelData.length > 0) {
      setData(
        modelData[0]?.model
          ? modelData[0]?.model?.map((item: any, index: number) => {
              return [
                item.modelType,
                Number(item.total),
                Number(item.onlineCount),
              ];
            })
          : modelData[0]?.wifiVersion?.map((item: any, index: number) => {
              return [
                item.wifiVersion,
                Number(item.total),
                Number(item.onlineCount),
              ];
            })
      );
    }
  }, [modelData]);
  // Highcharts configuration options
  const options = {
    color: ["#2CAFFE", "#32D74B"],
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: data.map((item) => item[0]),
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
        align: "high",
      },
      labels: {
        // overflow: 'justify'
      },
    },
    // tooltip: {
    //     valueSuffix: ' fruits'
    // },
    plotOptions: {
      column: {
        size: 10,
        dataLabels: {
          enabled: true,
        },
        pointWidth: 10,
        borderRadious: 10,
        groupPadding: 0.2,
        pointPadding: 0,
        borderWidth: 0,
        maxPointWidth: 50, // Max width of each column
        borderColor: "#0000FF", // Border color for the columns
      },
    },
    // legend: {
    //     layout: 'vertical',
    //     align: 'right',
    //     verticalAlign: 'bottom',
    //     x: 40,
    //     y: -80,
    //     floating: true,
    //     borderWidth: 1,
    //     backgroundColor: '#FFFFFF',
    //     shadow: true
    // },
    credits: {
      enabled: false,
    },
    series: [
      {
        // showInLegend: false,
        name: "Total",
        data: data.map((item) => item[1]),
        color: "#2CAFFE",
      },
      {
        // showInLegend: false,
        name: "Online",
        data: data.map((item) => item[2]),
        color: "#32D74B",
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ColumnChart;
